import { Zoom } from "@visx/zoom";
import { StateMap } from "../state-map";
import { TerritoryMap } from "../territory-map";
import "./styles.scss";
import classNames from "classnames";

export const background = "#f7f5f3";
export const statesBackgroundColor = "#777";

export const colors: string[] = ["#744DCA", "#3D009C", "#9020FF", "#C630FD"];

export type TerritoryMapProps = {
  width?: number;
  height?: number;
  events?: boolean;
  selectedDma?: string[];
  onDmaClick?: (dma: string) => void;
};

export const DmaMapContainer = ({
  width = 1200,
  height = 1000,
  events = true,
  selectedDma = [],
  onDmaClick,
}: TerritoryMapProps) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const maxHeight = 400;
  const initialScale = (width + height) / 1.55;
  //   const scale = (width + height) / 1.55;
  // const svgHeight = height >= maxHeight ? maxHeight : height;
  const svgHeight = height;

  return width < 10 ? null : (
    <Zoom<SVGSVGElement>
      width={width}
      height={svgHeight}
      scaleXMin={100}
      scaleXMax={10000}
      scaleYMin={100}
      scaleYMax={10000}
      initialTransformMatrix={{
        scaleX: initialScale,
        scaleY: initialScale,
        translateX: centerX,
        translateY: centerY,
        skewX: 0,
        skewY: 0,
      }}
    >
      {(zoom) => {
        return (
          <svg
            width={width}
            height={height}
            ref={zoom.containerRef}
            rx={14}
            className={classNames("dma-map", zoom.isDragging && "dragging")}
            style={{ touchAction: "none" }}
          >
            <rect
              x={0}
              y={0}
              width={width}
              height={svgHeight}
              fill={background}
              rx={14}
            />

            <StateMap width={width} zoom={zoom} />

            <TerritoryMap
              width={width}
              zoom={zoom}
              selectedDma={selectedDma}
              onDmaClick={onDmaClick}
              events={events}
            />
            {/** intercept all mouse events */}
            {/* <rect
              x={0}
              y={0}
              width={width}
              height={height}
              rx={14}
              fill="transparent"
              onTouchStart={zoom.dragStart}
              onTouchMove={zoom.dragMove}
              onTouchEnd={zoom.dragEnd}
              onMouseDown={zoom.dragStart}
              onMouseMove={zoom.dragMove}
              onMouseUp={zoom.dragEnd}
              onMouseLeave={() => {
                if (zoom.isDragging) zoom.dragEnd();
              }}
            /> */}
          </svg>
        );
      }}
    </Zoom>
  );
};
